module.exports = __webpack_public_path__ + "img/91.6dfaff00.jpg";